export enum EStatusSubscription {
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'inactive',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
  DISABLED = 'disabled',
  TRIAL = 'trial',
  PAYMENT_FAILURE = 'payment_failure'
}
export interface ISubscription {
  plan: ICurrentPlan;
  subscriptionId: string;
  status: EStatusSubscription;
  checkoutUrl: string | null;
  secondsUsage: string;
  creditsUsage: string;
  freeSeconds: string;
  freeCredits: string;
  amountSecondsLeft: string;
  amountCreditsLeft: string;
  linkedCardStatus: string;
  billingDate: string;
  nextPlanCode: string;
}

interface PlanDetails {
  details: {
    languages: string;
    watermarks: boolean;
    free_credits: number;
    free_seconds: number;
    trial_period: number;
    download_in_hd: boolean;
    pay_in_advance: boolean;
    premium_voices: boolean;
    stock_hq_avatar: boolean;
    custom_hq_avatar: boolean;
    price_per_credit: string;
    price_per_second: string;
    upload_voiceovers: boolean;
    custom_voice_clone: boolean;
    detail_description: string[];
    stock_talking_photo: boolean;
    gpt_script_generator: boolean;
    invoice_display_name: string;
    _custom_talking_photo: boolean;
    custom_hq_avatar_limit: number;
    estimated_render_speed: string;
    custom_video_share_pages: boolean;
    custom_talking_photo_limit: string;
    'premium_voice_previews_(free)': boolean;
    'custom_hq_avatar_free_(with_plan)': number;
    'custom_voice_clone_(free_with_plan)': number;
    'custom_talking_photo_free_(with_plan)': string;
    custom_voice_clone_eleven_labs_intergration: boolean;
  };
}
export interface ICurrentPlan {
  id: string;
  isActive: boolean;
  name: string;
  code: string;
  description: string;
  renewalType: 'yearly' | 'monthly' | 'weekly';
  amountCents: number;
  trialPeriod: number;
  subscriptionId: string;
  checkoutUrl: string;
  nextRenewalDate: string | null;
  planDetails?: PlanDetails;
  feature?: ICurrentPlanFeatures;
  isFree: boolean;
}

export interface ICurrentPlanFeatures {
  createAvatar: boolean;
  agents: boolean;
  api: boolean;
  express: boolean;
  extraCredits: boolean;
  premiumVoices: boolean;
  pro: boolean;
  speech: boolean;
  embed: boolean;
}
